import { styled } from "@mui/material/styles";
import ScrollbarsCustom from "../../../../explorer/components/ScrollbarsCustom/ScrollbarsCustom";
import { MiscSavio } from "../../../configuration/themeSettings";

export const Root = styled("div", { label: "AppContainer-root" })(
  ({ theme: Theme }) => ({
    display: "flex",
    flexDirection: "column",
    flex: "1 1 auto",
    width: '100%',

    "@media print": {
      display: 'block',
    }
  })
);

export const ScrollBars = styled(ScrollbarsCustom, {
  label: "AppContainer-scrollbars",
})(({ theme: Theme }) => ({
  position: "relative",
  display: "flex",
  flex: "1 1 auto",
  backgroundColor: Theme.palette.background.default,
  overflow: "auto",
  justifyContent: "center",
  "@media print": {
      display: 'block',
    }
}));

export const ContainerSite = styled(ScrollbarsCustom, {
  label: "AppContainer-containerSite",
})(({ theme: Theme }) => ({
  position: "relative",
  display: "flex",
  flex: "1 1 auto",
  width: '100%',
  maxWidth: MiscSavio.maxWidthSite,
}));
